import { staticColors } from '../const/colors/staticColors';
import { sizes } from '../const/sizes';
export const useFloatingSurfaceStyle = () => {
    return {
        backgroundColor: staticColors.floatingSurfaceBackground,
        borderRadius: sizes.floatingSurface.borderRadius,
        boxShadow: `${sizes.floatingSurface.boxShadowOffsetX} ${sizes.floatingSurface.boxShadowOffsetY} ${sizes.floatingSurface.boxShadowBlurRadius} ${staticColors.baseShadow}`,
    };
};
